import type { StrainsFilters } from 'lib/queries/strains';

import { useMemo } from 'react';

import { useWordPressContext } from 'contexts/wordpress-provider';

export function useStrainsArchiveFilters(): StrainsFilters {
  if (typeof window === 'undefined') {
    return null;
  }

  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const filters: StrainsFilters = {};

    for (const [key, value] of params) {
      if (key as keyof StrainsFilters) {
        let parsedValue = decodeURIComponent(value);

        try {
          parsedValue = JSON.parse(parsedValue);
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            console.warn(`filter ${key} is not valid JSON: ${error}`);
          }
        }

        filters[key] = parsedValue;
      }
    }

    return filters;
  }, [window.location.search]);
}

export function useStrainsArchiveUrl(props?: StrainsFilters): string {
  const { seoSettings, strainsArchivePage } = useWordPressContext();

  return useMemo(() => {
    if (!strainsArchivePage?.uri) {
      return '';
    }

    const url = new URL(strainsArchivePage.uri, seoSettings.siteUrl);

    for (const key in props) {
      url.searchParams.set(key, encodeURIComponent(JSON.stringify(props[key])));
    }

    return url.toString();
  }, [props, strainsArchivePage]);
}
